import { HTMLAttributes, MouseEventHandler } from "react";
import { cn } from "@util/helpers";

import SplideNextArrow from "./SplideNextArrow";
import SplidePrevArrow from "./SplidePrevArrow";

type SplideArrowsProps = Pick<HTMLAttributes<HTMLDivElement>, "className"> & {
  /** additional function to handle click events */
  onClick?: MouseEventHandler<HTMLButtonElement>;
};

export default function SplideArrows({
  className,
  onClick,
}: SplideArrowsProps): React.ReactElement {
  return (
    <div className={cn("splide__arrows", className)}>
      <SplidePrevArrow onClick={onClick} />
      <SplideNextArrow onClick={onClick} />
    </div>
  );
}
